angular.module("vgresiduos").controller("UnitEditCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			const params = [];
			if ($stateParams.tab) {
				params.push({ key: "tab", value: $stateParams.tab });
			}
			if ($stateParams.targetOrganizationId) {
				params.push({ key: "targetOrganizationId", value: $stateParams.targetOrganizationId });
			}
			if ($stateParams.countryId) {
				params.push({ key: "countryId", value: $stateParams.countryId });
			}
			if ($stateParams.organizationName) {
				params.push({ key: "organizationName", value: $stateParams.organizationName });
			}
			Vgr.util.redirectSingleton($rootScope, `unidade/editar/${$stateParams.id}`, params);
		};
	}
]);
